import { css } from 'twin.macro';
import { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import settingsRoutes from './settingRoutes';

const isDashboardPage = () => {
    try {
        return (window.location.href || '').split('settings#/')[1] === '';
    } catch (e) {
        return false;
    }
};

const loading = 'loading';

const TeamSettingsContent = ({ channelDetails }) => {
    const isDashboad = isDashboardPage();
    const styles = isDashboad
        ? `margin:  none ;padding: none;background: none ;min-height: 80vh;border-radius: 15px;`
        : `margin:  20px;padding:  2rem;background:  white;min-height: 80vh;border-radius: 15px;`;

    return (
        <div
            css={css`
                ${styles}
            `}
        >
            <Suspense fallback={loading}>
                <Switch>
                    {settingsRoutes.map((route, idx) => {
                        return (
                            route.component && (
                                <Route
                                    key={idx}
                                    path={route.path}
                                    exact={route.exact}
                                    name={route.name}
                                    render={(props) => <route.component {...props} channelDetails={channelDetails} />}
                                />
                            )
                        );
                    })}
                </Switch>
            </Suspense>
        </div>
    );
};
export default TeamSettingsContent;
